import { useEffect, useRef, useState } from 'react';

/**
 * True while `flag` is true, and for at least `minMs` after it last turned
 * true. Spec 10.1: "Saving" stays up long enough to read, so a quick save
 * does not flicker the status.
 *
 * `held` turns on during the render where the flag does (React's adjust
 * state while rendering pattern), so it is already in place when the flag
 * drops and nothing blinks; a timer turns it off.
 */
export function useHeldFlag(flag: boolean, minMs: number): boolean {
  const [held, setHeld] = useState(flag);
  if (flag && !held) setHeld(true);
  const shownAtRef = useRef(0);
  useEffect(() => {
    if (flag) {
      shownAtRef.current = Date.now();
      return;
    }
    if (!held) return;
    const left = minMs - (Date.now() - shownAtRef.current);
    const t = setTimeout(() => setHeld(false), Math.max(0, left));
    return () => clearTimeout(t);
  }, [flag, held, minMs]);
  return flag || held;
}
